import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BsFillTrashFill, BsPlusCircleFill, BsPrinterFill } from 'react-icons/bs';
import ResponseModal from '../../components/Modals/ResponseModal';
import { getProductsForSearchColombo, createCustomerInoviceColombo, displayAlert, hideAlert } from '../../features/Product/CustomerInvoice';
import PropagateLoader from 'react-spinners/PulseLoader';
import { generatallPDF } from '../../utils/InvoicePDF';
import { toast } from 'react-toastify';
import { PDFDownloadLink, pdf } from '@react-pdf/renderer';
import InvoicePDF from '../../utils/NewInvoice';

const AddCustomerInvoiceColombo = () => {
  const [searchText, setSearchText] = useState('');
  const [products, setproducts] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');

  const [customerDetails, setCustomerDetails] = useState({
    customerName: '',
    customerAddress: '',
    customerPhone: '',
    customerVatNo: '',
    discount: '',
    customerREFNo: '',
    SKREFNo: '',
    invoiceNo: '',
    labourCharges: '',
    transport: '',
    cleaningLiquid: '',
    cottonWaste: '',
    miscellaneous: '',
    outsideWorkshopCharges: '',
    workshopCharges: '',
  });

  const isAllItemsFilled = Object.keys(customerDetails)
    .filter(
      (key) =>
        ![
          'discount',
          'customerVatNo',
          'labourCharges',
          'transport',
          'cleaningLiquid',
          'cottonWaste',
          'miscellaneous',
          'outsideWorkshopCharges',
          'workshopCharges',
        ].includes(key),
    )
    .every((key) => !!customerDetails[key]);

  const dispatch = useDispatch();
  const { searchProducts, isLoading, alertType, alertText } = useSelector((state) => state.CustomerInvoice);

  const buttonHandler = (product) => {
    if (!products.filter((item) => item.id === product.id).length > 0) {
      setproducts((prevProducts) => [...prevProducts, { ...product, enteredQuantity: 0 }]);
      setErrorMessage('');
      setSearchText('');
    }
  };

  const removeProductHandler = (productId) => {
    setproducts((prevProducts) => prevProducts.filter((product) => product.id !== productId));
  };
  const calculateTotalPrice = () => {
    const { discount, labourCharges, transport, cleaningLiquid, cottonWaste, miscellaneous, outsideWorkshopCharges, workshopCharges } =
      customerDetails;

    // Calculate product total
    const productTotal = Object.values(products).reduce((sum, product) => {
      if (product.enteredQuantity <= product.quantity) {
        return sum + product.enteredQuantity * product.sellingPrice;
      }
      return sum;
    }, 0);

    // Convert all extra charge fields to numbers safely
    const extraCharges =
      Number(labourCharges) +
      Number(transport) +
      Number(cleaningLiquid) +
      Number(cottonWaste) +
      Number(miscellaneous) +
      Number(outsideWorkshopCharges) +
      Number(workshopCharges);

    // Subtract discount (if any)
    return productTotal + extraCharges - Number(discount || 0);
  };

  const inputHandler = (productId, quantity) => {
    setproducts((prevProducts) => prevProducts.map((product) => (product.id === productId ? { ...product, enteredQuantity: quantity } : product)));
  };

  //confirm button visibility
  const areAllItemsConfirmed = (products) => {
    return products.length > 0 && products.every((product) => product.enteredQuantity > 0 && product.quantity >= product.enteredQuantity);
  };

  //vat calculation for bill
  const totalPrice = calculateTotalPrice();
  const vatValue = (totalPrice * 18) / 100;
  const netTotal = totalPrice + vatValue;

  const confirmButtonHandler = () => {
    const productQuntity = areAllItemsConfirmed(products);
    if (!productQuntity) {
      // setErrorMessage('Entered quantity is greater than available quantity or not enterd customer quantity');
      return dispatch(
        displayAlert({ alertText: 'Entered quantity is greater than available quantity or not enterd customer quantity', alertType: 'error' }),
      );
    }

    dispatch(
      createCustomerInoviceColombo({
        ...customerDetails,
        total: totalPrice,
        vatAmount: vatValue,
        netTotal: netTotal,
        selectedProducts: products.map((product) => ({ productId: product.id, quantity: product.enteredQuantity })),
      }),
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const numericFields = [
      'discount',
      'labourCharges',
      'transport',
      'cleaningLiquid',
      'cottonWaste',
      'miscellaneous',
      'outsideWorkshopCharges',
      'workshopCharges',
    ];

    if (numericFields.includes(name)) {
      // Allow only digits and one optional decimal point
      const numericValue = value.replace(/[^0-9.]/g, '');

      // Prevent multiple dots (e.g., "12.3.4" becomes "12.34")
      const validValue = numericValue.split('.').length > 2 ? numericValue.substring(0, numericValue.lastIndexOf('.')) : numericValue;

      setCustomerDetails((prevState) => ({
        ...prevState,
        [name]: validValue,
      }));
      return;
    }

    setCustomerDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    dispatch(getProductsForSearchColombo(searchText));
  }, [searchText]);

  useEffect(() => {
    if (products.length === 0) {
      setCustomerDetails((prevState) => ({
        ...prevState,
        discount: 0,
      }));
    }
  }, [products]);

  const formRest = () => {
    setCustomerDetails({
      customerName: '',
      customerAddress: '',
      customerPhone: '',
      discount: '',
      customerREFNo: '',
      customerVatNo: '',
      SKREFNo: '',
      invoiceNo: '',
      labourCharges: 0,
      transport: 0,
      cleaningLiquid: 0,
      cottonWaste: 0,
      miscellaneous: 0,
      outsideWorkshopCharges: 0,
      workshopCharges: 0,
    });
    setproducts([]);
  };

  const ModalCloseHandler = () => {
    if (alertType === 'success') {
      formRest();
    }

    dispatch(hideAlert());
  };

  const override = {
    display: 'block',
    margin: '0 auto',
    borderColor: 'red',
  };

  // const productQuntity = areAllItemsConfirmed(products);

  const buttonVisibility = products?.length > 0 && isAllItemsFilled;

  const handleDownload = async () => {
    const hasZeroQuantity = products.some((p) => p.enteredQuantity === 0);
    const hasAtLeastOne = products.some((p) => p.enteredQuantity > 0);

    if (hasZeroQuantity) {
      toast.error('Please remove products with quantity 0 before generating the invoice.');
      return;
    }

    if (!hasAtLeastOne) {
      toast.error('Please add at least one product to generate the invoice.');
      return;
    }

    const blob = await pdf(<InvoicePDF customerDetails={customerDetails} products={products} totalPrice={totalPrice} />).toBlob();

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Mr.${customerDetails.customerName}_invoice.pdf`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className=" max-w-7xl flex justify-center flex-col mx-auto relative">
      <div className="bg-gray-200 p-2 rounded-lg mb-2">
        <h2 className="text-xs sm:text-lg md:text-xl lg:text-xl font-semibold text-center">Add Customer Invoice (Kandy)</h2>
        <ResponseModal open={alertText} alertText={alertText} alertType={alertType} closeHandler={ModalCloseHandler} />
        <h2 className="font-semibold">Product Search</h2>
        <div className="w-full relative">
          <input
            className="w-full p-2 rounded-md border border-gray-300 mb-5 font-semibold text-gray-600"
            type="text"
            value={searchText}
            onChange={(text) => setSearchText(text.target.value)}
            placeholder="Search for products..."
          />

          {searchText && searchProducts.length > 0 && (
            <ul className="bg-blue-700 p-2 w-full overflow-y-scroll absolute text-center rounded-md z-10 max-h-60">
              {searchProducts.map((product) => (
                <li className="" key={product.id}>
                  <button onClick={() => buttonHandler(product)} className="text-white font-semibold">
                    {product.productName} - Rs.{product.sellingPrice}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="flex flex-col md:flex-row justify-between gap-5 mb-5">
          <div className="w-full md:-3/5">
            <label className="block mb-2 font-semibold">Customer Name</label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="customerName"
              value={customerDetails.customerName}
              onChange={handleChange}
            />
          </div>

          <div className="w-full md:-3/5">
            <label className="block mb-2 font-semibold">Address</label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="customerAddress"
              value={customerDetails.customerAddress}
              onChange={handleChange}
            />
          </div>

          <div className="w-full md:-3/5">
            <label className="block mb-2 font-semibold">Phone Number</label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="customerPhone"
              value={customerDetails.customerPhone}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between gap-5 mb-5">
          <div className="w-full md:-3/5">
            <label className="block mb-2 font-semibold">Invoice No</label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="invoiceNo"
              value={customerDetails.invoiceNo}
              onChange={handleChange}
            />
          </div>

          <div className="w-full md:-3/5">
            <label className="block mb-2 font-semibold">Customer REF No/S </label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="customerREFNo"
              value={customerDetails.customerREFNo}
              onChange={handleChange}
            />
          </div>

          <div className="w-full md:-3/5">
            <label className="block mb-2 font-semibold">Customer VAT No</label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="customerVatNo"
              value={customerDetails.customerVatNo}
              onChange={handleChange}
            />
          </div>

          <div className="w-full md:-3/5">
            <label className="block mb-2 font-semibold">SK REF No/S </label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="SKREFNo"
              value={customerDetails.SKREFNo}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* other chargers */}
        <div className="flex flex-col md:flex-row justify-between gap-5 mb-5">
          <div className="w-full md:-3/5">
            <label className="block mb-2 font-semibold">Labour Charges</label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="labourCharges"
              value={customerDetails.labourCharges}
              onChange={handleChange}
            />
          </div>

          <div className="w-full md:-3/5">
            <label className="block mb-2 font-semibold">Transport</label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="transport"
              value={customerDetails.transport}
              onChange={handleChange}
            />
          </div>

          <div className="w-full md:-3/5">
            <label className="block mb-2 font-semibold">Cleaning Liquid</label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="cleaningLiquid"
              value={customerDetails.cleaningLiquid}
              onChange={handleChange}
            />
          </div>

          <div className="w-full md:-3/5">
            <label className="block mb-2 font-semibold">Cotton Waste</label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="cottonWaste"
              value={customerDetails.cottonWaste}
              onChange={handleChange}
            />
          </div>
        </div>
        {/* other chargers */}
        {/* other chargers */}
        <div className="flex flex-col md:flex-row justify-between gap-5 mb-5">
          <div className="w-full md:-3/5">
            <label className="block mb-2 font-semibold">Miscellaneous</label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="miscellaneous"
              value={customerDetails.miscellaneous}
              onChange={handleChange}
            />
          </div>

          <div className="w-full md:-3/5">
            <label className="block mb-2 font-semibold">Outside Workshop Charges</label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="outsideWorkshopCharges"
              value={customerDetails.outsideWorkshopCharges}
              onChange={handleChange}
            />
          </div>

          <div className="w-full md:-3/5">
            <label className="block mb-2 font-semibold">Workshop Charges</label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="workshopCharges"
              value={customerDetails.workshopCharges}
              onChange={handleChange}
            />
          </div>
        </div>
        {/* other chargers */}

        <div className="flex flex-col md:flex-row justify-between gap-5 mb-5 items-center ">
          <div className="w-full md:3/5">
            <label className="block mb-2 font-semibold">Discount</label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="discount"
              value={customerDetails.discount}
              onChange={handleChange}
              // onChange={(text) => setDiscount(text.target.value)}
            />
          </div>

          <div className="w-full md:w3/5">
            <label className="block mb-2 font-semibold">Total</label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="total"
              value={totalPrice}
              disabled={true}
            />
          </div>

          <div className="w-full md:w3/5">
            <label className="block mb-2 font-semibold">VAT 18%</label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="total"
              value={vatValue}
              disabled={true}
            />
          </div>

          <div className="w-full md:w3/5">
            <label className="block mb-2 font-semibold">Net Total</label>
            <input
              className="block p-2 w-full rounded-lg  bg-gray-50 border border-gray-300 font-semibold text-gray-600"
              type="text"
              name="total"
              value={netTotal}
              disabled={true}
            />
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-center sm:justify-end items-center gap-5 ">
          <div className=" flex flex-row gap-x-2 items-center">
            <label className="block text-lg font-semibold">Quotation status</label>
            <input className="block  rounded-lg  bg-gray-50 border border-gray-300 " type="checkbox" name="total" value={totalPrice} />
          </div>

          <button
            className={`text-white sm:self-end w-32  p-2 bg-blue-700 rounded-md ${!buttonVisibility && 'opacity-50 cursor-not-allowed'}`}
            disabled={isLoading || !buttonVisibility}
            onClick={confirmButtonHandler}
          >
            {isLoading ? (
              <PropagateLoader
                color={'white'}
                loading={isLoading}
                cssOverride={override}
                size={5}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            ) : (
              'Confirm Invoice'
            )}
          </button>

          <div>
            <button
              className={`text-white  p-2 bg-blue-700 rounded-md ${!buttonVisibility && `opacity-50 cursor-not-allowed`}`}
              title="Export PDF"
              disabled={isLoading || !buttonVisibility}
              onClick={handleDownload}
            >
              <BsPrinterFill size={24} />
            </button>
          </div>
        </div>
      </div>

      <table className="table-auto w-full">
        <thead className="bg-black sticky top-0">
          <tr>
            <th className="text-white  px-4 py-3 text-left">Product Name</th>
            <th className="text-white  px-4 py-3 text-left hidden sm:table-cell">Available Quntity</th>
            <th className="text-white  px-4 py-3 text-left hidden sm:table-cell">Cost</th>
            <th className="text-white  px-4 py-3 text-left hidden sm:table-cell">Selling Price</th>
            <th className="text-white  px-4 py-3 text-left">Customer Quantity</th>
            <th className="text-white  px-4 py-3 text-left hidden sm:table-cell">Action</th>
          </tr>
        </thead>
        <tbody>
          {Object.values(products).map((product) => {
            const isQuantityExceeded = product.enteredQuantity > product.quantity;
            return (
              <tr className={`odd:bg-white  even:bg-gray-200`} key={product.id}>
                <td className={`text-gray-950 p-5 font-semibold ${isQuantityExceeded ? 'text-red-600 font-semibold' : ''}`}>{product.productName}</td>
                <td className={`text-gray-950 p-5 font-semibold ${isQuantityExceeded ? 'text-red-600 font-semibold' : ''}`}>{product.quantity}</td>
                <td className={`text-gray-950 p-5 font-semibold hidden sm:table-cell ${isQuantityExceeded ? 'text-red-600 font-semibold' : ''}`}>
                  {product.unitCost}
                </td>
                <td className={`text-gray-950 p-5 font-semibold hidden sm:table-cell ${isQuantityExceeded ? 'text-red-600 font-semibold' : ''}`}>
                  {product.sellingPrice}
                </td>
                <td className={`text-gray-950 p-5 font-semibold hidden sm:table-cell ${isQuantityExceeded ? 'text-red-600 font-semibold' : ''}`}>
                  <input
                    className="border p-2 border-black rounded-md font-semibold"
                    type="text"
                    inputMode="numeric"
                    value={product.enteredQuantity?.toString() || ''}
                    onChange={(e) => {
                      const value = e.target.value;

                      // Allow only digits
                      if (/^\d*$/.test(value)) {
                        inputHandler(product.id, parseInt(value || '0', 10));
                      }
                    }}
                    placeholder="Enter quantity..."
                  />
                </td>
                <td className="text-blue-700 p-5 flex flex-row items-center cursor-pointer">
                  {/* <BsPlusCircleFill
                    className="mr-3"
                    size={20}
                    title="Update quantity"
                    name="Update quantity"
                    onClick={() => validateAndAddQuantity(product, product.id)}
                  /> */}
                  <BsFillTrashFill size={20} title="Delete" onClick={() => removeProductHandler(product.id)} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AddCustomerInvoiceColombo;
